import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { returnQuery } from "../../../../../../../utils/methods/returnQuery";
import { Box, Checkbox, IconButton, Tooltip } from "@mui/material";
import { HeaderRowCheckBox } from "../../../../../../calendar/pages/main/components/headerRowCheckBox";
import { Constants } from "../../../../../../../utils/constants";
import { icons } from "../../../../../../../utils/icons";
import { useTranslation } from "react-i18next";
import { useStyles } from "../styles";
import { FilterBody } from "../../../../../../../hooks/filter/typing";
import { ItemMenu } from "../../../../../../questionnaire/pages/main/typing/types";
import { formatFilterMain, menuItems } from "../../../constans";
import { OptionMenu } from "../../../../../../calendar/pages/main/types";
import { Roles, Types } from "../../../../../../../utils/enums";
import { useNavigate } from "react-router-dom";
import { userGroupServiceFetch } from "../../../../../../../utils/constants/callService";
import { formatUserGroupList } from "../../../../../../../service/userGroup/format";
import { RowItemGroup } from "../../../../../../../service/userGroup/response";
import { getLocalStorage } from "../../../../../../../utils/crud/crypt";
import { Local } from "../../../../../../logbook/pages/main/components/shared/formActivity/create/types";


const useTable = ({
    isChecked,
    selectedIds,
    setSelectedIds,
    setIsChecked,
    notGroupSelected,
    setNotGroupSelected,
    fitlerMain
}: {
    setIsChecked: Dispatch<SetStateAction<boolean>>,
    selectedIds: number[], isChecked: boolean,
    setSelectedIds: Dispatch<SetStateAction<number[]>>,
    notGroupSelected: number[],
    setNotGroupSelected: Dispatch<SetStateAction<number[]>>,
    fitlerMain: FilterBody;
}) => {

    const { t } = useTranslation()
    const styles = useStyles()
    const storage: Local = getLocalStorage()
    const navigate = useNavigate()
    const [tableLoading, setTableLoading] = useState(false)
    const refTime = useRef<NodeJS.Timeout | null>(null)
    const [totalPages, setTotalPages] = useState(0)
    const [isLoadingDelete, setIsLoadingDelete] = useState(false)
    const [snackbarOpen, setSnackbarOpen] = useState({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })

    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void
    }>({
        open: false,
        title: t('userGroup.modal.titles.confirmation'),
        description: '',
        confirm: () => { },
    })


    const [detail, setDetail] = useState<{
        id: number
        positionMenu: Record<string, unknown>
        anchor: null | HTMLButtonElement
        menu: ItemMenu[]
    }>({
        id: 0,
        positionMenu: {},
        anchor: null,
        menu: menuItems,
    })

    const closeSnackBarOpen = () => {
        setSnackbarOpen(prev => ({ ...prev, open: false }))
    }

    const closeModalDelete = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    const handleHeaderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedIds([]);
        setNotGroupSelected([]);
        if (event.target.checked) {
            setIsChecked(true)
        } else {
            setIsChecked(false)
        }
    };

    const [row, setRow] = useState<RowItemGroup[]>([])

    const getGroupList = async () => {
        setTableLoading(true)
        const response = await userGroupServiceFetch.getListGroups({ query: returnQuery({ ...fitlerMain.query, filter: fitlerMain.query.filter?.replaceAll('+', '%2B') }, formatFilterMain) })
        const { row } = formatUserGroupList({ response })

        if (!response?.errors) {
            setRow(row)
            setTotalPages(response.totalPages)
        }

        setTableLoading(false)
    }

    useEffect(() => {
        if (refTime.current) { clearTimeout(refTime.current) }

        refTime.current = setTimeout(() => {
            getGroupList()
            setSelectedIds([]);
            setNotGroupSelected([]);
            setIsChecked(false)
        }, 300)
    }, [fitlerMain.query.all])

    const column = [
        {
            field: 'checkbox',
            headerName: '',
            headerCell: styles?.mineHeaderTable,
            label: (
                <Checkbox
                    checked={isChecked}
                    onChange={handleHeaderChange}
                    color="primary"
                />
            ),
            renderCell: (params: any) => {
                return (
                    <HeaderRowCheckBox
                        id={params.row.id}
                        isChecked={isChecked}
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                        notFolioSelected={notGroupSelected}
                        setNotFolioSelected={setNotGroupSelected}
                        disabled={false}
                    />
                )
            }
        },
        {
            id: 'name',
            label: t('userGroup.columns.groupName'),
            headerCell: styles?.headerTable,
            sortable: true
        },
        ...(storage?.role === Roles.ADMIN
            ? [
                {
                    id: 'creatorUser',
                    label: t('userGroup.columns.creatorUser'),
                    headerCell: styles?.headerTable,
                    sortable: true,
                },
            ]
            : []),
        {
            id: 'internalUsers',
            label: t('userGroup.columns.numberOfInternalUsers'),
            headerCell: styles?.headerTable,
            sortable: true
        },
        {
            id: 'externalUsers',
            label: t('userGroup.columns.numberOfExternalUsers'),
            headerCell: styles?.headerTable,
            sortable: true
        },
        {
            id: 'createTime',
            label: t('userGroup.columns.createDate'),
            headerCell: styles?.headerTable,
            sortable: true
        },
        {
            id: 'actions',
            label: t('userGroup.columns.actions'),
            minWidth: 50,
            renderCell: (params: any) => {
                const id = params?.row?.id
                return (
                    <Box sx={styles.containerStatus}>
                        <Tooltip title={t('ToolTips.seeActions')}>
                            <IconButton
                                onClick={(e) => {
                                    setDetail({
                                        id,
                                        positionMenu:
                                            row?.length < Constants.numberOfRows
                                                ? {
                                                    top: 0,
                                                    left: '-30px',
                                                }
                                                : {
                                                    top: `${e.clientY}px`,
                                                    left: `${e.clientX - 120}px`,
                                                },
                                        anchor: e.currentTarget,
                                        menu: menuItems,
                                    })
                                }}
                            >
                                {icons('moreHoriz')}
                            </IconButton>
                        </Tooltip>
                    </Box>
                )
            },
        },
    ]

    const closeMenu = () => {
        setDetail((prev) => ({
            ...prev,
            anchor: null,
        }))
    }

    const optionMenu: OptionMenu = ({ item, type }) => {
        const menu: { [x: string]: () => void } = {
            '1': () => {
                navigate(`../detail/${detail.id}`)
            },
            '2': () => {
                navigate(`../edit/${detail.id}?from=list`)
            },
            '3': () => {
                navigate(`../permission/${detail.id}`)
            },
            '4': () => {
                setModal(prev => ({
                    ...prev,
                    open: true,
                    title: t('userGroup.modal.titles.areYouSureWantDeleteThisGroupSelected'),
                    description: t('userGroup.modal.description.areYouSureWantDeleteThisGroupSelected'),
                    confirm: () => { handleDeleteUnique() },
                }))
            }
        }

        menu[item?.value]?.()
    }

    const handleOpenModalDelete = () => {
        if (selectedIds.length === 0 && !isChecked) {
            setSnackbarOpen(prev => ({
                ...prev,
                open: true,
                message: t('userGroup.snackbar.selectAtLeastOneGroup'),
                type: Types.ERROR
            }))
        } else {
            setModal(prev => ({
                ...prev,
                open: true,
                title: t('userGroup.modal.titles.areYouSureWantDeleteAllGroupsSelected', { count: selectedIds.length }),
                description: t('userGroup.modal.description.areYouSureWantDeleteAllGroupsSelected', { count: selectedIds.length }),
                confirm: () => { handleDeleteMasive() },
            }))
        }
    }

    const handleDeleteMasive = async () => {
        setIsLoadingDelete(true)

        const payload = {
            all: isChecked,
            ids: isChecked ? [] : selectedIds,
            notIds: isChecked ? notGroupSelected : []
        };
        const response = await userGroupServiceFetch.deleteMasive(payload, isChecked ? returnQuery({ ...fitlerMain.query, filter: fitlerMain.query.filter?.replaceAll('+', '%2B') }, formatFilterMain) : undefined);

        if (response.code == '00') {
            setSnackbarOpen(prev => ({ ...prev, open: true, message: t("userGroup.snackbar.masive.success"), type: Types.SUCCESS }))
            getGroupList()
            setSelectedIds([]);
            setNotGroupSelected([]);
            setIsChecked(false)
        } else {
            setSnackbarOpen(prev => ({ ...prev, open: true, message: t("userGroup.snackbar.masive.error"), type: Types.ERROR }))
        }

        setIsLoadingDelete(false)
        closeModalDelete()
    }

    const handleDeleteUnique = async () => {
        setIsLoadingDelete(true)

        const response = await userGroupServiceFetch.deleteGroupById(Number(detail.id))

        if (response.code == '01') {
            setSnackbarOpen(prev => ({ ...prev, open: true, message: t("userGroup.snackbar.delete.success"), type: Types.SUCCESS }))
            getGroupList()
            setSelectedIds([]);
            setNotGroupSelected([]);
            setIsChecked(false)
        } else {
            setSnackbarOpen(prev => ({ ...prev, open: true, message: t("userGroup.snackbar.delete.error"), type: Types.ERROR }))
        }

        setIsLoadingDelete(false)
        closeModalDelete()
    }




    return { isLoadingDelete, snackbarOpen, modal, closeSnackBarOpen, closeModalDelete, column, row, detail, setDetail, tableLoading, totalPages, closeMenu, optionMenu, handleOpenModalDelete }
}



export { useTable }